import React, { Component } from 'react';
import PropTypes from 'prop-types';
import apiFetch from 'utils/apiFetch';

import ArrowBack from 'assets/images/ArrowBack.svg';
import InfoCircle from 'assets/images/InfoCircle.svg';
import lensBlack from 'assets/images/lens.svg';

import AvatarNew from 'components/AvatarNew';
import _ from 'lodash';
import FilterChat from './FilterChat';

import {
  NewChatContainer, NewChatHeader, NewChatGrid,
} from './styles';

class NewChat extends Component {
  state = {
    filter: '',
  }


  handleCreateChat = (event) => {
    const { addNewChat } = this.props;
    const userId = parseInt(event.currentTarget.getAttribute('data-user_id'), 10);
    const params = {
      user: userId,
    };

    apiFetch('POST', { endPoint: 'chat' }, params)
      .then((chat) => {
        addNewChat(chat);
      });
  }

  filterChat = (value) => {
    if (value === '') {
      this.setState({ filter: '' });
    } else {
      this.setState({ filter: value });
    }
  }

  printGridUsers = () => {
    const { filter } = this.state;
    const { userConnections, chats } = this.props;
    let usersFiltered = [];
    let users = [];

    if (userConnections) {
      const lowerFilter = filter.toLowerCase();
      usersFiltered = _.filter(userConnections, (user) => {
        // If already exists a chat with this user
        if (_.find(chats, chat => (!_.has(chat.element_related, 'type') && chat.users.length === 2 && _.find(chat.users, { id: user.id })))) {
          return false;
        }
        const completeName = (`${user.firstname} ${user.lastname}`).toLowerCase();

        if (!lowerFilter || completeName.includes(lowerFilter)) {
          return true;
        }
        return false;
      });
      users = usersFiltered.map((user) => {
        return (
          <div style={{ cursor: 'pointer' }} onClick={this.handleCreateChat} key={user.id} data-user_id={user.id}>
            <AvatarNew avatar={user.avatar} firstname={`${user.firstname} ${user.lastname}`} id={user.id} />
          </div>
        );
      });
    }

    return users;
  }


  printChatGrid = () => {
    return (
      <NewChatGrid>
        {this.printGridUsers()}
      </NewChatGrid>
    );
  }

  printFilterChat = () => {
    return (
      <div className='filter_chat'>
        <FilterChat doFilter={this.filterChat} />
      </div>
    );
  }

  handleBackArrow = () => {
    const { closeNewChat } = this.props;
    closeNewChat();
  }

  render() {
    const { literals } = this.props;
    return (
      <NewChatContainer className='all_screen_mobile'>
        <NewChatHeader>
          <button className='arrowback' onClick={this.handleBackArrow}>
            <img src={ArrowBack} alt='' />
          </button>
          <div>
            {literals.newChat}
          </div>
          {}
        </NewChatHeader>
        {this.printFilterChat()}
        <div className='new_chat_title'>
          {literals.newChatTitle}
        </div>
        {this.printChatGrid()}
      </NewChatContainer>

    );
  }
}

NewChat.propTypes = {
  literals: PropTypes.object.isRequired,
  closeNewChat: PropTypes.func.isRequired,
  // app: PropTypes.object.isRequired,
  // user: PropTypes.object.isRequired,
  // fetchChats: PropTypes.func.isRequired,
  chats: PropTypes.array.isRequired,
  userConnections: PropTypes.array.isRequired,
  addNewChat: PropTypes.func.isRequired,
};

export default NewChat;



// WEBPACK FOOTER //
// ./src/components/Chats/components/NewChat.jsx